import { Schema } from 'effect';

// Coordinate bounds for OCR word/paragraph positioning
const CoordBounds = Schema.Tuple([
  Schema.Finite, // x1
  Schema.Finite, // y1
  Schema.Finite, // x2
  Schema.Finite, // y2
]);

// OCR coordinate with page reference
const OcrCoord = Schema.Struct({
  page: Schema.Int,
  coords: CoordBounds,
});

// Word-level OCR data (immutable in S3)
// NOTE: NO tts_hash_id here - stored in chapter_details.tts_chunks JSONB, assembled at API response time
// NOTE: NO start_ms/end_ms here - TTS timing comes from DB tts_cache_voices
const WordTimestamp = Schema.Struct({
  text: Schema.String,
  page: Schema.Int,
  coords: Schema.optional(Schema.Array(OcrCoord)),
});

// Sentence containing words
const SentenceTimestamp = Schema.Struct({
  word_timestamps: Schema.Array(WordTimestamp),
  coords: Schema.optional(Schema.Array(OcrCoord)),
});

// Paragraph containing sentences
const ParagraphTimestamp = Schema.Struct({
  sentence_timestamps: Schema.Array(SentenceTimestamp),
  coords: Schema.optional(Schema.Array(OcrCoord)),
  reading_class: Schema.optional(Schema.String),
});

// Full chapter timestamps hierarchy
const ChapterTimestamps = Schema.Struct({
  paragraph_timestamps: Schema.Array(ParagraphTimestamp),
});

/**
 * Schema for chapter OCR data stored in S3.
 *
 * This is immutable after creation - only contains OCR extraction results.
 * TTS-related data (voice, lang, tts_hash_id, timing) is stored in Postgres
 * and assembled with this data at API response time.
 *
 * @see docs/projects/planning/audio-conversion-migration.md
 */
export const ChapterOcrData = Schema.Struct({
  text: Schema.optional(Schema.String), // TODO: remove this field, we can reconstruct it from the timestamps
  timestamps: ChapterTimestamps,
});

export type ChapterOcrData = typeof ChapterOcrData.Type;

// Export sub-schemas for reuse
export {
  ChapterTimestamps,
  ParagraphTimestamp,
  SentenceTimestamp,
  WordTimestamp,
};
